import React from 'react';
import assign from 'object-assign';
import MenuItem from 'material-ui/MenuItem';
import PropTypes from 'prop-types';

import Form from '../Common/Form.react';
import { addValidationRule } from 'formsy-react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import DatePicker from '../Common/DatePicker';
import TimePicker from '../Common/TimePicker';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import AutoComplete from '../Common/AutoComplete';
import { createPills } from '../Common/Pill';

import { Card, CardText } from 'material-ui/Card';

import EventNotificationSettings from './EventNotificationSettings';
import EventActions from '../../actions/EventActionCreator';
import EventStore from '../../stores/EventStore';
import EventNotificationStore from '../../stores/EventNotificationStore';

import VenueActions from '../../actions/VenueActionCreator';
import VenueStore from '../../stores/VenueStore';
import LocationActions from '../../actions/LocationActionCreator';
import LocationStore from '../../stores/LocationStore';

import ThemeActions from '../../actions/ThemeActionCreator';
import ThemeStore from '../../stores/ThemeStore';

import PeriodicTypeActions from '../../actions/PeriodicTypeActionCreator';
import PeriodicTypeStore from '../../stores/PeriodicTypeStore';

import UserActions from '../../actions/UserActionCreator';
import TrainerStore from '../../stores/TrainerStore';

import ConfirmSavePeriodicEventDialog from '../Common/ConfirmSavePeriodicEventDialog';
import { withId } from '../Common/Decorators';
import { formatName } from '../../utils/StringUtils';

const url = '/dashboard/events';
const visibilityOptions = ['private', 'public'];
const endTypeOptions = [
    {value: 'afterRepeat', name: 'For'},
    {value: 'onDate', name: 'Until'}
];

const EventForm = React.createClass({

    getInitialState: function () {
        const isEdit = !!this.props.id;
        const isFromTemplate = !!this.props.templateId;
        let timeStart = null;
        let timeEnd = null;

        if (!isEdit && !isFromTemplate) {
            timeStart = new Date();
            timeEnd = new Date();
            timeEnd.setMinutes(timeEnd.getMinutes() + 15);
        }

        return {
            isEdit,
            isFromTemplate,
            details: {
                id: '',
                name: '',
                identificationNumber: '',
                description: '',
                capacity: '0',
                minCapacity: '0',
                price: '',
                displayGuests: false,
                displayQR: false,
                displayCapacity: false,
                displayRemaining: false,
                visibility: 'private',
                venue: '',
                venueId: 0,
                locationId: 0,
                type: 'event',
                status: 'active',
                theme: 'default',
                timeRegistration: timeStart,
                timeStart,
                timeEnd,
                dateStart: timeStart,
                dateEnd: timeEnd,
                periodic: false,
                periodTypeId: 0,

                periodicEndsOn: null,
                periodicEndsAfterCount: 1,
                endType: 'never',
                attendanceLocked: false,
                accessGroupId: '',
                accessGroup: '',
                waitingListCapacity: '',
                attendeeCount: 0,
                trainers: []
            },
            notifications: [],
            periodType: [],

            statusOptions: [],
            themeOptions: [],
            venueOptions: [],
            locationOptions: [],
            trainerOptions: [],

            endsOnEnable: false,
            endsAfterCountEnable: false,
            confirm: {
                open: false,
                data: null
            },
            periodic: false,
            waitingList: false
        }
    },
    componentWillMount: function() {
        this.setValidations();
    },

    componentDidMount: function() {

        this.listeners = [
            LocationStore.addListener(this._onChangeLocation),
            ThemeStore.addListener(this.onDropdownOptionsChange.bind(this, 'themeOptions', ThemeStore)),
            VenueStore.addListener(this.onDropdownOptionsChange.bind(this, 'venueOptions', VenueStore)),
            EventStore.addListener(this._onChange),
            EventNotificationStore.addListener(this.onNotificationsChange),
            PeriodicTypeStore.addListener(this._onChange),
            TrainerStore.addListener(this.onTrainersChange)
        ];

        EventActions.getStatusOptions();

        if (this.state.isEdit) {
            EventActions.getById(this.props.eventId);
            EventActions.listNotifications(this.props.eventId)
        } else if (this.state.isFromTemplate) {
            EventActions.getById(this.props.routeParams.templateId);
        }

        ThemeActions.getAll({sort: 'listOrder'});
        VenueActions.getAll();

        PeriodicTypeActions.getAll();
        UserActions.getTrainers();
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());
    },

    render: function () {
        const isAdmin = this.context.auth.isAdmin();
        const formTitle = (this.state.isEdit ? this.state.details.name : 'New event');
        //when periodic type  or start date or end date were changed then current periodic event will be deleted
        let redirectTo = (this.state.isEdit && !this.state.details.periodic ? `/dashboard/event/${this.state.details.id}` : url);

        const periodicChildren = this.renderPeriodicEvent();

        let accessGroups;
        if (!!this.context.auth.identity && !!this.context.auth.identity.accessGroups && 0 < this.context.auth.identity.accessGroups.length) {
            accessGroups = this.context.auth.identity.accessGroups;
        } else {
            accessGroups = {id: this.state.details.accessGroupId, name: this.state.details.accessGroup};
        }

        return(
            <Form
                title={formTitle}
                onSave={this._onSave}
                redirectTo={redirectTo}
            >
                <Card className="cent-card">
                    <CardText>
                        <div className="cent-flex-row">
                            <div className="cent-col-1">
                                <TextField
                                    name="name"
                                    hintText="Name"
                                    validations="minLength:2,maxLength:80"
                                    validationError="Please use only numbers and letters, at least 2"
                                    value={this.state.details.name}
                                    floatingLabelText="Name"
                                    required
                                />
                            </div>
                            <div className="cent-col-1">
                                <TextField
                                    name="description"
                                    value={this.state.details.description}
                                    multiLine={true}
                                    hintText="Description"
                                    floatingLabelText="Description"
                                />
                            </div>
                            <div className="cent-col-1">
                                <TextField
                                    name="identificationNumber"
                                    hintText="Identification Number"
                                    validations="maxLength:12"
                                    validationError="Please use no more than 12 characters"
                                    value={this.state.details.identificationNumber}
                                    floatingLabelText="Identification Number"
                                />
                            </div>
                            {this.state.details.dateStart && (this.state.details.type !== 'template') &&
                                <div className="cent-col-2">
                                    <DatePicker
                                        name="timeStart"
                                        value={new Date(this.state.details.dateStart)}
                                        floatingLabelText="Start date"
                                        onChange={this._onChangeTimeStart}
                                        required
                                    />
                                </div>
                            }
                            {this.state.details.timeStart && (
                                <div className="cent-col-2">
                                    <TimePicker
                                        name="timeStart2"
                                        value={new Date(this.state.details.timeStart)}
                                        floatingLabelText="Start time"
                                        required
                                    />
                                </div>
                            )}
                            {(this.state.details.dateEnd && this.state.details.type !== 'template') && (
                                <div className="cent-col-2">
                                    <DatePicker
                                        name="timeEnd"
                                        value={new Date(this.state.details.dateEnd)}
                                        floatingLabelText="End date"
                                        onChange={(e,value) => this.setState({details: assign({}, this.state.details, { dateEnd: value }) })}
                                        required
                                    />
                                </div>
                            )}
                            {this.state.details.timeEnd && (
                                <div className="cent-col-2">
                                    <TimePicker
                                        name="timeEnd2"
                                        value={new Date(this.state.details.timeEnd)}
                                        floatingLabelText="End time"
                                        required
                                    />
                                </div>
                            )}
                            <div className="cent-col-2">
                                <TimePicker
                                    name="timeRegistration"
                                    value={!!this.state.details.timeRegistration ? new Date(this.state.details.timeRegistration) : null}
                                    floatingLabelText="Registration time"
                                />
                            </div>
                            <div className="cent-col-1">
                                {periodicChildren}
                            </div>
                            <h2>Location</h2>
                            <p className="subHeading">Venue, location and capacity settings</p>
                            <div className="cent-col-2">
                                <SelectField
                                    name="venueId"
                                    value={this.state.details.venueId}
                                    floatingLabelText="Venue"
                                    onChange={this.onVenueUpdate}
                                >
                                    <MenuItem key="none" value={0} primaryText="N/A"/>
                                    {this.state.venueOptions.map((venue) => {
                                        const capacity = (venue.capacity !== undefined ? `[ ${venue.capacity} ]` : '');
                                        return (
                                            <MenuItem
                                                key={venue.id}
                                                value={venue.id}
                                                primaryText={`${venue.name} ${capacity}`}
                                                disabled={venue.status !== 'available'}
                                            />
                                        )
                                    })}
                                </SelectField>
                            </div>
                            <div className="cent-col-2">
                                <SelectField
                                    name="locationId"
                                    key={`locationForVenue${this.state.details.venueId}`}
                                    value={this.state.details.locationId}
                                    floatingLabelText="Location"
                                >
                                    <MenuItem key="none" value={0} primaryText="N/A" />
                                    {this.state.locationOptions.map( ({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)}
                                </SelectField>
                            </div>
                            <div className="cent-col-2">
                                <TextField
                                    name="capacity"
                                    value={this.state.details.capacity}
                                    validations={`isNumeric,checkCapacity:${this.state.details.capacity}`}
                                    validationErrors={{isNumeric: "Please use only numbers", checkCapacity: `This event already has ${this.state.details.attendeeCount} attendees`}}
                                    hintText="Max. Capacity"
                                    floatingLabelText="Max. Capacity"
                                />
                            </div>
                            <div className="cent-col-2">
                                <TextField
                                    name="minCapacity"
                                    value={this.state.details.minCapacity}
                                    validations="isNumeric"
                                    validationError="Please use only numbers"
                                    hintText="Min. Capacity"
                                    floatingLabelText="Min. Capacity"
                                />
                            </div>
                            <div>
                                <h2>Trainers</h2>
                                <p className="subHeading">Select the trainers for this event</p>
                            </div>
                            <div className="cent-col-1">
                                <AutoComplete
                                    name="trainers"
                                    floatingLabelText="Trainers"
                                    dataSource={this.createTrainerOptions()}
                                    onNewRequest={this.onSelectTrainer}
                                    maxSearchResults={10}
                                    fullWidth
                                />
                                <div className="cent-form-chips">{this.createTrainerPills()}</div>
                            </div>
                            <h2>Display</h2>
                            <p className="subHeading">Elements selected here will be viewable to the end user</p>
                            <div className="cent-col-1">
                                <div className="cent-checkbox-wrapper">
                                    <Checkbox
                                        name="displayCapacity"
                                        value={this.state.details.displayCapacity}
                                        label="Capacity"
                                    />
                                </div>
                            </div>
                            <div className="cent-col-1">
                                <div className="cent-checkbox-wrapper">
                                    <Checkbox
                                        name="displayGuests"
                                        value={this.state.details.displayGuests}
                                        label="Guest list"
                                    />
                                </div>
                            </div>
                            <div className="cent-col-1">
                                <div className="cent-checkbox-wrapper">
                                    <Checkbox
                                        name="displayRemaining"
                                        value={this.state.details.displayRemaining}
                                        label="Remaining places"
                                    />
                                </div>
                            </div>
                            <div className="cent-col-1">
                                <div className="cent-checkbox-wrapper">
                                    <Checkbox
                                        name="displayQR"
                                        value={this.state.details.displayQR}
                                        label="QR code"
                                    />
                                </div>
                            </div>
                            <div className="cent-col-1">
                                <SelectField
                                    name="theme"
                                    value={this.state.details.theme}
                                    hintText="Theme"
                                    floatingLabelText="Theme"
                                    required
                                >
                                    {this.state.themeOptions.map(({id, name}) => (<MenuItem key={id} value={name} primaryText={name} /> ))}
                                </SelectField>
                            </div>
                            <h2>Accessibility</h2>
                            <p className="subHeading">Configure how users will access this event</p>
                            <div className="cent-col-2">
                                <SelectField
                                    name="visibility"
                                    value={this.state.details.visibility}
                                    floatingLabelText="Visibility"
                                >
                                    {visibilityOptions.map((visibility) => (<MenuItem key={visibility} value={visibility} primaryText={visibility}/>))}
                                </SelectField>
                            </div>
                            <div className="cent-col-2">
                                <SelectField
                                    name="status"
                                    value={this.state.details.status}
                                    hintText="status"
                                    floatingLabelText="status"
                                    required
                                >
                                    {this.state.statusOptions.map(({id, name}) => (<MenuItem key={id} value={name} primaryText={name} /> ))}
                                </SelectField>
                            </div>
                            <div className="cent-col-1">
                                <SelectField
                                    name="accessGroupId"
                                    value={this.state.details.accessGroupId}
                                    hintText="Access Group"
                                    floatingLabelText="Access Group"
                                >
                                    {accessGroups.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)}
                                </SelectField>
                            </div>
                            <h2>Waiting List</h2>
                            <p className="subHeading">Configure event waiting list</p>
                            <div className="cent-col-1">
                                <div className="cent-checkbox-wrapper">
                                    <Checkbox
                                        name="waitingList"
                                        value={this.state.waitingList}
                                        label="Enabled"
                                        onChange={() => this.setState({waitingList: !this.state.waitingList})}
                                    />
                                </div>
                                {this.state.waitingList &&

                                    <div className="cent-checkbox-wrapper">
                                        <Checkbox
                                            name="attendanceLocked"
                                            value={this.state.details.attendanceLocked}
                                            label="Add new bookings to waiting list"
                                        />
                                    </div>
                                }
                            </div>
                            {this.state.waitingList &&
                                <div className="cent-col-2">
                                    <TextField
                                        name="waitingListCapacity"
                                        value={this.state.details.waitingListCapacity === -1 ? '' : this.state.details.waitingListCapacity}
                                        validations="isNumeric"
                                        validationError="Please use only numbers"
                                        hintText="Limit"
                                        floatingLabelText="Limit"
                                    />
                                </div>
                            }
                            {isAdmin && (
                                <div>
                                    <h2>Notifications</h2>
                                    <p className="subHeading">Configure event notifications</p>
                                    <EventNotificationSettings notifications={this.state.notifications} />
                                </div>
                            )}
                        </div>
                        {<ConfirmSavePeriodicEventDialog
                            open={this.state.confirm.open}
                            onSaveAll={this.onSavePeriodic.bind(this, 'all')}
                            onSaveCurrent={this.onSavePeriodic.bind(this, 'current')}
                            onSaveFollowing={this.onSavePeriodic.bind(this, 'follow')}
                            onClose={this.handleClose}
                        />}
                    </CardText>
                </Card>
            </Form>
        );
    },

    renderPeriodicEvent: function() {
        return (
            <section>

                <SelectField
                    name="periodTypeId"
                    value={this.state.details.periodTypeId || 0}
                    disabled={this._periodTypeIsEditable()}
                    hintText="Repeat"
                    floatingLabelText="Repeat"
                    onChange={this._onChangePeriodTypeId}
                    required>
                    <MenuItem key="root" value={0} primaryText="No" />
                    {this.state.periodType.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)}
                </SelectField>

                {this.state.details.periodic &&
                    <SelectField
                        name="endType"
                        value={this.state.details.endType}
                        floatingLabelText="Repeating"
                        required
                        onChange={this._onChangeEndType}>
                        {endTypeOptions.map((endType) => (<MenuItem key={endType.value} value={endType.value} primaryText={endType.name} />))}
                    </SelectField>
                }
                {this.state.endsAfterCountEnable &&
                    <TextField
                        name="periodicEndsAfterCount"
                        value={this.state.details.periodicEndsAfterCount}
                        validations="isNumeric"
                        validationError="Please use only numbers"
                        hintText="After occurrences"
                        floatingLabelText="After occurrences"
                        required
                    />
                }
                {this.state.endsOnEnable && (
                    <DatePicker
                        name="periodicEndsOn"
                        value={this.state.details.periodicEndsOn==null ? this._shiftDate(31) : new Date(this.state.details.periodicEndsOn)}
                        floatingLabelText="Ends on"
                        required
                    />
                )}

            </section>
        );
    },

    _shiftDate: function(days){
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + days);
        return currentDate;
    },

    _periodTypeIsEditable: function() {
        if (this.state.details.timeEnd !== null && this.state.isEdit) {
            const currentDate = new Date();
            const endDate = new Date(this.state.details.timeEnd);
            return (endDate < currentDate);
        }
        return false;
    },

    _setPeriodTypeDropdown: function(periodTypes, timeStart) {
        if (periodTypes.length === 0) { return []; } //guard

        if (isNaN(timeStart.getTime())) {
            timeStart = new Date();
        }

        const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        const weeks = ["1st", "2nd", "3rd", "4th", "last"];
        const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

        const startDay = timeStart.getDay();
        const startDate = timeStart.getDate();
        const startMonth = timeStart.getMonth();

        let prevWeek = new Date();
        prevWeek.setDate(startDate - 7);
        let currentWeek = startDate;
        let week = 0;
        let isCurrentMonth = true;
        while (isCurrentMonth) {
            if (prevWeek.getDate() > currentWeek)
                isCurrentMonth = false;
            else {
                currentWeek = prevWeek.getDate();
                prevWeek.setDate(prevWeek.getDate() - 7);
                week++;
            }
        }

        periodTypes.forEach(({id}, i) => {
            switch (id) {
                case 1:
                    periodTypes[i].name = "Daily";
                    break;
                case 2:
                    periodTypes[i].name = "Weekly";
                    break;
                case 6:
                    periodTypes[i].name = `Monthly on the ${startDate}`;
                    break;
                case 7:
                    periodTypes[i].name = `Monthly on the ${weeks[week]} ${days[startDay]}`;
                    break;
                case 8:
                    periodTypes[i].name = `Annually on ${startDate} ${months[startMonth]}`;
                    break;
            }
        });

        return periodTypes;
    },

    onVenueUpdate: function(event, value) {
        if (value !== this.state.details.venueId) {
            const details = assign({}, this.state.details, {venueId: value, locationId: 0});
            this.setState({details});
            if (!!value) {
                LocationActions.getAllByVenue(value);
            }
        }
    },

    _onChangeTimeStart: function(event, value) {
        const periodType = this._setPeriodTypeDropdown([...this.state.periodType], value);
        const details = assign({}, this.state.details, { dateStart: value });
        this.setState({ periodType, details });
    },

    _onChangePeriodTypeId: function(event, value) {
        const periodic = (value !== 0);
        const endsOnEnable = (periodic && this.state.details.endType === 'onDate');
        const endsAfterCountEnable = (periodic && this.state.details.endType === 'afterRepeat');

        const details = assign({}, this.state.details, {periodTypeId: value, periodic});

        this.setState({
           details: details,
           endsOnEnable: endsOnEnable,
           endsAfterCountEnable: endsAfterCountEnable
        });
    },

    _onChangeEndType: function(event, value) {
        const details = assign({}, this.state.details, { endType: value });
        //['never','afterRepeat','onDate']
        const endsOnEnable = (this.state.details.periodic && value === 'onDate');
        const endsAfterCountEnable = (this.state.details.periodic && value === 'afterRepeat' );
        this.setState({
            details: details,
            endsOnEnable: endsOnEnable,
            endsAfterCountEnable: endsAfterCountEnable
        });
    },

    _onCancel: function() {
        document.location.href = (this.state.isEdit ? `/dashboard/event/${this.state.details.id}` : url);
    },

    _onSave: function(data) {
        if (this.state.details.type !== 'template') {
            data.timeStart.setHours(data.timeStart2.getHours());
            data.timeStart.setMinutes(data.timeStart2.getMinutes());
            data.timeStart.setSeconds(data.timeStart2.getSeconds());

            data.timeEnd.setHours(data.timeEnd2.getHours());
            data.timeEnd.setMinutes(data.timeEnd2.getMinutes());
            data.timeEnd.setSeconds(data.timeEnd2.getSeconds());

            if (!!data.timeRegistration) {
                data.timeRegistration.setFullYear(data.timeStart.getFullYear(), data.timeStart.getMonth(), data.timeStart.getDate());
            }
        } else {
            data.timeStart = data.timeStart2;
            data.timeEnd = data.timeEnd2;
        }

        data.periodic = this.state.details.periodic;

        if (data.periodic) {
            data.periodicRepeatCount = 1;

            if (data.periodTypeId === 2) {
                const repeatDay = data.timeStart.getDay();

                data.periodicRepeatOnSunday    = (repeatDay === 0);
                data.periodicRepeatOnMonday    = (repeatDay === 1);
                data.periodicRepeatOnTuesday   = (repeatDay === 2);
                data.periodicRepeatOnWednesday = (repeatDay === 3);
                data.periodicRepeatOnThursday  = (repeatDay === 4);
                data.periodicRepeatOnFriday    = (repeatDay === 5);
                data.periodicRepeatOnSaturday  = (repeatDay === 6);
            }
        }

        data.timeStart = data.timeStart.toString().replace(/\s\([^)]+\)/, '');
        data.timeEnd = data.timeEnd.toString().replace(/\s\([^)]+\)/, '');

        if (data.timeRegistration) {
            data.timeRegistration = data.timeRegistration.toString().replace(/\s\([^)]+\)/, '');
        }

        if (!data.waitingList) {
            data.waitingListCapacity = 0;
        } else if (data.waitingListCapacity === ''){
            data.waitingListCapacity = -1;
        }

        if (!!this.state.details.trainers) {
            data.trainers = this.state.details.trainers;
        }

        if (this.state.isEdit) {
            const event = EventStore.getById(this.props.eventId);
            if (event.periodic) {
                this.handleOpen(data);
            } else {
                return EventActions.update(this.props.eventId, data);
            }

        } else {
            return EventActions.save(data);
        }
    },

    _onChange: function() {
        let details = assign({}, this.state.details);
        let periodic = assign({}, this.state.periodic);

        if(this.state.isEdit) {
            const event = EventStore.getById(this.props.eventId);
            if (event) {
                details.timeStart = new Date(event.timeStart);
                details.timeEnd = new Date(event.timeEnd);
                details.dateStart = details.timeStart;
                details.dateEnd = details.timeEnd;

                details = assign({}, details, event);
                periodic = details.periodic;
                if (!!details.venueId) {
                    LocationActions.getAllByVenue(details.venueId);
                }
            }
        } else if (this.state.isFromTemplate){
            let event = EventStore.getById(this.props.templateId);
            if (event !== undefined) {
                event = assign({}, event, {id: '', type: 'event'});
                details = assign(details, event);

                details.dateStart = new Date();
                details.dateEnd = new Date();
                details.timeStart = new Date(event.timeStart);
                details.timeEnd = new Date(event.timeEnd);
                details.timeRegistration = new Date(event.timeRegistration);
                if (isNaN(details.timeStart.getTime())) {
                    details.timeStart = details.dateStart;
                }
                if (isNaN(details.timeEnd.getTime())) {
                    details.timeEnd = details.dateEnd;
                }
                if (isNaN(details.timeRegistration.getTime())) {
                    details.timeRegistration = details.timeStart;
                }

                periodic = details.periodic;
                LocationActions.getAllByVenue(details.venueId);
            }
        }
        let periodType = PeriodicTypeStore.getAll();
        let timeStart;
        if (this.state.isEdit) {
            timeStart = new Date(details.timeStart);
        } else if (this.state.isFromTemplate) {
            timeStart = new Date();
        } else {
            timeStart = details.timeStart;
        }

        const endsOnEnable         = details.periodic && details.endType === 'onDate';
        const endsAfterCountEnable = details.periodic && details.endType === 'afterRepeat';

        details.venueId = details.venueId || 0;
        details.locationId = details.locationId || 0;

        this.setState({
            details,
            periodType: this._setPeriodTypeDropdown(periodType, timeStart),
            endsOnEnable,
            endsAfterCountEnable,
            periodic,
            statusOptions: EventStore.getStatusOptions(),
            templates: EventStore.getByType('template'),
            waitingList: details.waitingListCapacity !== 0
        });
    },

    onNotificationsChange: function() {
        const notifications = EventNotificationStore.getByEvent(this.props.eventId);
        if (!!notifications) {
            this.setState({notifications});
        }
    },

    onDropdownOptionsChange: function(dropdown, Store) {
        const options = Store.getAll();
        if (options !== undefined) {
            this.setState({ [dropdown]: options });
        }
    },

    _onChangeLocation: function() {
        const locationOptions = LocationStore.getAllByVenue(this.state.details.venueId);
        this.setState({locationOptions});
    },

    onTrainersChange: function() {
        const trainerOptions = TrainerStore.getAll();
        if (!!trainerOptions) {
            this.setState({trainerOptions});
        }
    },

    /* Confirm edit support  */

    onSavePeriodic: function(mode) {
        const data = assign({}, this.state.confirm.data, {mode});
        EventActions.update(this.props.id, data);
        this.handleClose();
    },

    handleOpen: function(data) {
        this.setState({ confirm: { open: true, data: data } });
    },

    handleClose: function() {
        this.setState({ confirm: { open: false } });
    },

    setValidations: function() {
        addValidationRule('checkCapacity', (values, value) => (!value || Number(value) >= Number(this.state.details.attendeeCount)));
    },

    createTrainerPills: function () {
        const deleteAction = (trainer) => this.setState({details: {...this.state.details, trainers: this.state.details.trainers.filter((id) => id !== trainer)}});
        return createPills(this.state.details.trainers, this.state.trainerOptions, deleteAction);
    },

    createTrainerOptions: function () {
        if (!this.state.trainerOptions) { return []; }
        return this.state.trainerOptions.map((trainer) => {
            const name = formatName(trainer);
            return {
                text: name,
                trainer,
                value: <MenuItem key={trainer.id} value={trainer.id} primaryText={name}/>
            }
        });
    },

    onSelectTrainer: function ({trainer}) {
        if (this.state.details.trainers.includes(trainer.id)) { return null; }
        this.setState({details: {...this.state.details, trainers: [...this.state.details.trainers, trainer.id]}})
    }

});

EventForm.contextTypes = {
    auth: PropTypes.object.isRequired
};

const getId = ({routeParams}) => ({
    id: Number(routeParams.id) || null,
    eventId: Number(routeParams.id || routeParams.templateId) || null,
    templateId: Number(routeParams.templateId) || null
});

export default withId(EventForm, getId);
